// stores/categoriesStore.ts
import { defineStore } from 'pinia'
import { useNuxtApp } from '#app'
import { categoriesRepository } from '@/utils/categoriesRepository'
import type { PlaceCategory } from '~/types/types'

export const useCategoriesStore = defineStore('categories', {
  state: () => ({
    mainCategories: [] as PlaceCategory[],
    subCategories: {} as { [key: number]: PlaceCategory[] }, // keyed by category id
    subSubCategories: {} as { [key: number]: PlaceCategory[] } // keyed by sub-category id
  }),
  actions: {
    async fetchMainCategories() {
      const { $api } = useNuxtApp()
      try {
        const repo = categoriesRepository($api)
        const categories = await repo.get()
        this.mainCategories = categories
      } catch (error) {
        console.error('Error fetching main categories:', error)
        throw error
      }
    },
    async fetchSubCategories(categoryId: number) {
      const { $api } = useNuxtApp()
      try {
        const repo = categoriesRepository($api)
        const subs = await repo.getSubCategories(categoryId)
        this.subCategories[categoryId] = subs.filter(sub => true)
      } catch (error) {
        console.error(`Error fetching subcategories for category ${categoryId}:`, error)
        throw error
      }
    },
    async fetchSubSubCategories(subCategoryId: number) {
      const { $api } = useNuxtApp()
      try {
        const repo = categoriesRepository($api)
        const subs = await repo.getSubSubCategories(subCategoryId)
        this.subSubCategories[subCategoryId] = subs.filter(ss => true)
      } catch (error) {
        console.error(`Error fetching sub‑subcategories for subcategory ${subCategoryId}:`, error)
        throw error
      }
    }
  }
})
